import type { ServerError } from "@/api/hooks/errorShape";

/**
 * Extracts the user-facing error message from a ky HTTPError processed by
 * errorShapeHook, falling back to the raw error message for non-HTTP errors
 * (e.g. local validation throws).
 */
export const parseErrorMessage = (err: unknown): string =>
  (err as { cleanError?: ServerError }).cleanError?.message ??
  (err instanceof Error ? err.message : "Unknown error");
